// react
import React from 'react'
// antd-pro
import {ProFormSelect, ProFormText} from '@ant-design/pro-components'
import Api from '@/api'
import {AppType} from '@/enum'

/**
 * 销售易配置表单项
 * @constructor
 */
const XIAOSHOUYIFormItems = () => {
  return (
    <>
      <ProFormText
        name={["config", "grant_type"]}
        label={"grant_type"}
        placeholder={"请输入grant_type"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入grant_type"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "client_id"]}
        label={"client_id"}
        placeholder={"请输入client_id"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入client_id"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "client_secret"]}
        label={"client_secret"}
        placeholder={"请输入client_secret"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入client_secret"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "username"]}
        label={"username"}
        placeholder={"请输入username"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入username"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "password"]}
        label={"password"}
        placeholder={"请输入password"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入password"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "serverUrl"]}
        label={"serverUrl"}
        placeholder={"请输入serverUrl"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入serverUrl"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "remark"]}
        label={"remark"}
        placeholder={"请输入remark"}
        width={"lg"}
        rules={[
          {
            message: "请输入remark"
          }
      ]}
      />
    </>
  )
}

export default XIAOSHOUYIFormItems
